import * as yup from 'yup';

import { MULTISELECT_ADDITIONAL_FIELD_MAX_CHARACTERS } from '../constants';
import { type IAdditionalFieldConfig } from '../types/response';
import { type TValidationConfig } from '../types/configs';
import { FieldPrefix } from '../constants/fieldPrefixes';
import { DataType } from '../types/enums';

import {
  addFieldConfigValidation,
  getArrayValidation,
  getBooleanValidation,
  getDateValidation,
  getNumberValidation,
  getObjectValidation,
  getStringValidation,
} from './validations';

const getValidation = (
  field: IAdditionalFieldConfig,
  entityPrefix: FieldPrefix,
  operation?: string,
  validationConfig?: TValidationConfig
) => {
  const { dataType, id, maxLength, minValue, maxValue } = field;
  const fieldName = `${entityPrefix}${FieldPrefix.additionalFields}${FieldPrefix.additionalField}${id}`;

  switch (dataType) {
    case DataType.CHECKBOX:
      return getBooleanValidation({ field: fieldName, operation });
    case DataType.DECIMAL:
    case DataType.INTEGER:
      return getNumberValidation({ field: fieldName, operation, min: minValue, max: maxValue });
    case DataType.TEXT:
    case DataType.TEXTAREA:
      return getStringValidation({ field: fieldName, operation, max: maxLength, validationConfig });
    case DataType.DATE:
      return getDateValidation({ field: fieldName, operation });
    case DataType.LIST:
      return getObjectValidation({ field: fieldName, operation });
    case DataType.MULTI_SELECT_LIST:
      return getArrayValidation({
        field: fieldName,
        operation,
        maxCharacters: MULTISELECT_ADDITIONAL_FIELD_MAX_CHARACTERS,
      });
    default:
      return addFieldConfigValidation(yup.mixed())({ field: fieldName, operation });
  }
};

const getAdditionalFieldsSchemaShape = (
  fields: IAdditionalFieldConfig[],
  entityPrefix: FieldPrefix,
  operation?: string,
  validationConfig?: TValidationConfig
) => {
  const schema: Record<string, yup.Schema> = {};
  fields.forEach((field) => {
    schema[`${FieldPrefix.additionalField}${field.id}`] = getValidation(
      field,
      entityPrefix,
      operation,
      validationConfig
    );
  });

  return schema;
};

export default getAdditionalFieldsSchemaShape;
